import * as React from "react";
import { FindEquipmentAdditionalFilter } from "../../../components/FindEquipmentAdditionalFilter";
import { Display } from "../../../../../../components/Display";
import { Loader } from "../../../../../../components/Utils/loader/Loader";
import { SpinnerSize } from "@vebox/etui-core";
import { DeviceModelsList } from "../../../components/DeviceModelsList";
import { FindEquipmentContext } from "../../../providers/FindEquipmentProvider";
import { ADDITIONAL_FILTERS } from "../../../types";
import { AppTranslations } from "../../../../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface TelemetryFilterFilterProps {
	open?: boolean;
}

export const TelemetryFilter: React.FC<TelemetryFilterFilterProps> = ({
	open,
}) => {
	const { deviceModels } = React.useContext(FindEquipmentContext);
	const { selectedAdditionalFilter } = React.useContext(FindEquipmentContext);

	const isLoading = React.useMemo(
		() => deviceModels?.isValidating || deviceModels?.isLoading,
		[deviceModels?.isValidating, deviceModels?.isLoading],
	);

	return (
		<FindEquipmentAdditionalFilter
			name={AppTranslations.filters.equipment.telemetryTitle}
			active={selectedAdditionalFilter.includes(
				ADDITIONAL_FILTERS.DEVICE_MODELS,
			)}
			open={open}
			openIfActive={true}
		>
			<Display isVisible={isLoading}>
				<Loader relativelyCentered={true} spinnerSize={SpinnerSize.small} />
			</Display>
			<Display
				isVisible={
					!isLoading &&
					deviceModels?.data &&
					deviceModels?.data?.list?.length > 0
				}
			>
				<DeviceModelsList devicesModels={deviceModels?.data?.list} />
			</Display>
		</FindEquipmentAdditionalFilter>
	);
};
